namespace appn {
    export interface INameValuePair {
        name: string;
        value: any;
    }
    
    export interface IMethodResult {
        message: string;
        success: boolean;
    }

    export interface IRequestUser {
        id: number;
        isSuperUserOrLoggedInAs: boolean;
        isAdminOrHigher: boolean;
        isUserOrHigher: boolean;
        type: UserType;
        masterId: number;
        vendorId: number;
        isDirectCustomer: boolean;
        language: string;
        isPExpired: boolean;
        isFirstSession: boolean;
        allowUsageAnalytics: boolean | null;
    }

    export interface IRequestProvider {
        id: number;
        isImperial: boolean;
        name: string;
        isTrialing: boolean;
    }

    export interface IAppnUrls {
        root: string;
        account: {
            setLanguage: string,
            settings: string;
        };
        folders: {
            removeItem: string;
            organise: string;
        };
        notifications: {
            index: string;
            total: string;
            delete: string;
            deleteAll: string;
            reschedule: string;
            rescheduleAll: string;
        };
        introduction: {
            index: string;
        };
        services: {
            ajaxValidateDateFormat: string;
            ajaxPing: string;
            ajaxFindLocation: string;
        };
        taskTemplates: {
            wizard1: string;
        };
    }

    export interface IAppnStrings {
        activeUsers: string;
        choose: string;
        chooseScreen: string;
        formEntries: string;
        dataSource: string;
        date: string;
        deleteMessage: string;
        deleteTitle: string;
        errorRetrievingData: string;
        latestFormEntries: string;
        noResultsFound: string;
        optional: string;
        organiseDocs: string;
        organiseScreens: string;
        organiseSyncs: string;
        recentActivity: string;
        searchStartsWith: string;
        showArchived: string;
        showRetired: string;
        trashMessage: string;
        trashTitle: string;
        value: string;
        viewLess: string;
        viewMore: string;
        fileSizeMax: string;
        fileSizeMaxKB: string;
        unsupportedFileType: string
    }

    export interface FormElement {
        name: string;
        questionText: string;
        xPathRef: string;
        elementType: any;
        seqNo: number;
        level: number;
        parentName: string;
        numChildren: number;
        dataSourceId?: any;
        staticOptions: { [index: string]: string; };
        listBindType?: any;
        boundListId?: any;
        boundColIndex?: number;
        boundDataName: string;
        stepOptions: any[];
        hasGeo?: boolean;
        isPersonalData?: boolean;
        precision?: number;
        numLines?: number;
    }

    export enum UserStatus {
        Invited = 'Invited',
        Active = 'Active',
        Inactive = 'Inactive'
    }

    export enum UserType {
        Full = 'Full', // Grandfathered. Order is important
        Premium = 'Premium',
        Standard = 'Standard',
        Edge = 'Edge',
        Pro = 'Pro'
    }

    export enum DataSourceType {
        UserDefined = 'UserDefined',
        Connected = 'Connected',
        System = 'System',
        App = 'App'
    }

    export type Guid = string;

    export interface Dictionary<T> {
        [Key: string]: T;
    }

    export interface AppnSelectListItem extends SelectListItem {
        dataTag: string;
        dataValue: string;
        hint: string;
        dataTag2: string;
        dataValue2: string;
        dataTag3: string;
        dataValue3: string;
    }

    export interface SelectListGroup {
        Disabled: boolean;
        Name: string;
    }

    export interface SelectListItem {
        disabled: boolean;
        group: SelectListGroup;
        selected: boolean;
        text: string;
        value: string;
    }

    export enum TwoFactorAuthMode {
        Disabled = 'Disabled',
        EnabledPortalOnly = 'EnabledPortalOnly',
        EnabledPortalAndApp = 'EnabledPortalAndApp'
    }

    export enum TwoFactorAuthPreferredApp {
        None = 'None',
        OnePassword = 'OnePassword',
        Authy = 'Authy',
        BitWarden = 'BitWarden',
        Google = 'Google',
        LastPass = 'LastPass',
        Microsoft = 'Microsoft',
        Other = 'Other'
    }

    export enum XeroApi {
        None = '',
        Accounting = 'Accounting',
        PayrollAU = 'PayrollAU',
        PayrollNZ = 'PayrollNZ',
        PayrollUK = 'PayrollUK'
    }
    
    export enum XeroEndpoint {
        Accounts = 'Accounts',
        Contacts = 'Contacts',
        Employees = 'Employees',
        Invoices = 'Invoices',
        Items = 'Items',
        Timesheet = 'Timesheet',
        TrackingCategories = 'TrackingCategories'
    }

    export enum QuickBooksOnlineEndpoint
    {
        None = '',
        Customer = 'Customer',
        Invoice = 'Invoice',
        TimeActivity = 'TimeActivity',
        Class = 'Class'
    }
    
    export enum QuickBooksOnlineOperation
    {
        None = '',
        Create = 'Create',
        FullUpdate = 'FullUpdate',
        SparseUpdate = 'SparseUpdate'
    }
} 
